module.exports = __webpack_public_path__ + "img/01.67756b48.png";